'use client'

// Route-level error boundary. Catches anything thrown by a server or client
// component below the root layout — the header / sidebar / nav stay rendered.
// global-error.tsx is the last-resort fallback when this itself fails.
//
// All behavior lives in ErrorReportCard: crash reporting (Sentry + the
// error_occurrences trail), the Claude explanation, and the prefilled support
// email. This file only adapts the Next.js boundary props.

import { ErrorReportCard } from '@/components/errors/error-report-card'

export default function RouteError({
  error,
  reset,
  ...rest
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  // Next 16.2 also passes unstable_retry, which re-fetches the segment instead
  // of just re-rendering it — the right retry for server errors (the docs'
  // recommendation over reset). Read from rest because the serializable-props
  // lint doesn't recognize the new boundary prop yet.
  const retry = (rest as { unstable_retry?: () => void }).unstable_retry
  return <ErrorReportCard error={error} retryAction={retry ?? reset} />
}
